@use "../styles.module.scss";

.main {
  &.single {
    margin: 48px 2% 0 2%;
  }
}
